// src/pages/Investment/InvestmentPlansPage.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { investmentService } from '../../services/investmentService';
import InvestmentPlanCard from '../../components/Investment/InvestmentPlanCard';
import './InvestmentPlansPage.css';

const InvestmentPlansPage = () => {
  const navigate = useNavigate();
  const [investments, setInvestments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filter, setFilter] = useState('all'); // 'all', 'active', 'matured', 'withdrawn'

  useEffect(() => {
    fetchInvestments();
  }, []);

  const fetchInvestments = async () => {
    try {
      setLoading(true);
      const data = await investmentService.getUserInvestments();
      setInvestments(data);
    } catch (err) {
      setError(err.message || 'Failed to fetch investments');
    } finally {
      setLoading(false);
    }
  };

  const filteredInvestments = investments.filter(investment => {
    switch (filter) {
      case 'active':
        return investment.status === 'ACTIVE' || investment.status === 'PARTIALLY_WITHDRAWN';
      case 'matured':
        return investment.status === 'MATURED';
      case 'withdrawn':
        return investment.status === 'WITHDRAWN';
      default:
        return true;
    }
  });

  const handleWithdrawalSuccess = () => {
    // Refresh investments after successful withdrawal
    fetchInvestments();
  };

  if (loading) {
    return (
      <div className="investment-plans-page">
        <div className="loading">Loading your investments...</div>
      </div>
    );
  }

  return (
    <div className="investment-plans-page">
      {/* Header */}
      <div className="investment-plans-header">
        <button 
          className="back-button"
          onClick={() => navigate('/dashboard')}
        >
          ← Back to Dashboard
        </button>
        <div className="header-content">
          <h1>My Investment Plans</h1>
          <p>Manage and withdraw from your investments</p>
        </div>
      </div>

      {/* Filter Tabs */}
      <div className="investment-filters">
        <button 
          className={`filter-tab ${filter === 'all' ? 'active' : ''}`}
          onClick={() => setFilter('all')}
        >
          All Investments
        </button>
        <button 
          className={`filter-tab ${filter === 'active' ? 'active' : ''}`}
          onClick={() => setFilter('active')}
        >
          Active
        </button>
        <button 
          className={`filter-tab ${filter === 'matured' ? 'active' : ''}`}
          onClick={() => setFilter('matured')}
        >
          Matured
        </button>
        <button 
          className={`filter-tab ${filter === 'withdrawn' ? 'active' : ''}`}
          onClick={() => setFilter('withdrawn')}
        >
          Withdrawn
        </button>
      </div>

      {/* Error Message */}
      {error && (
        <div className="error-message">
          {error}
          <button onClick={fetchInvestments} className="retry-button">
            Try Again
          </button>
        </div>
      )}

      {/* Investments Grid */}
      <div className="investments-grid">
        {filteredInvestments.length === 0 ? (
          <div className="no-investments">
            <p>No investments found</p>
            {filter !== 'all' && (
              <button 
                className="view-all-button"
                onClick={() => setFilter('all')}
              >
                View All Investments
              </button>
            )}
          </div>
        ) : (
          <div className="investments-list">
            {filteredInvestments.map(investment => (
              <InvestmentPlanCard
                key={investment.id}
                investment={investment}
                onWithdrawalSuccess={handleWithdrawalSuccess}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default InvestmentPlansPage;